import React, { useEffect } from 'react';
// import { useTranslation } from 'react-i18next';

const DatenschutzPage: React.FC = () => {
  // const { t, i18n } = useTranslation();
  // const currentLang = i18n.language;
  const currentLang = 'en'; // Default to English

  useEffect(() => {
    document.title = `Privacy Policy | Fork:it`; // Always English
  }, []); // Removed currentLang from dependencies

  return (
    <div className="bg-white">
      <div className="container mx-auto px-4 py-16 md:py-24">
        <h1 className="text-4xl md:text-5xl font-lexend font-bold mb-12 text-center">
          Privacy Policy
        </h1>

        <div className="max-w-3xl mx-auto prose lg:prose-lg">
          <h2>Privacy at a Glance</h2>
          
          <h3>General Information</h3>
          <p>
            The following information provides a simple overview of what happens to your personal data when you visit this website. Personal data is any data that can be used to identify you personally.
          </p>

          <h3>Data Collection on This Website</h3>
          <h4>Who is responsible for data collection on this website?</h4>
          <p>
            The data processing on this website is carried out by the website operator. Their contact details can be found in the imprint of this website.
          </p>

          <h4>How do we collect your data?</h4>
          <p>
            Some data is collected when you provide it to us. This could, for example, be data you enter into a contact form.
          </p>
          <p>
            Other data is collected automatically by our IT systems when you visit the website. This is primarily technical data (e.g., internet browser, operating system, or time of page view). This data is collected automatically as soon as you enter this website.
          </p>

          <h4>What do we use your data for?</h4>
          <p>
            Part of the data is collected to ensure the error-free provision of the website. Other data can be used to analyze your user behavior.
          </p>

          <h4>What rights do you have regarding your data?</h4>
          <p>
            You have the right at any time to receive information free of charge about the origin, recipient, and purpose of your stored personal data. You also have a right to request the correction or deletion of this data. If you have given your consent to data processing, you can revoke this consent at any time for the future. You also have the right, under certain circumstances, to request the restriction of the processing of your personal data. Furthermore, you have the right to lodge a complaint with the competent supervisory authority.
          </p>
          <p>
            For this purpose, as well as for further questions on the subject of data protection, you can contact us at any time at the address given in the imprint.
          </p>

          <h2>General Information and Mandatory Information</h2>
          <h3>Data Protection</h3>
          <p>
            The operators of these pages take the protection of your personal data very seriously. We treat your personal data confidentially and in accordance with the statutory data protection regulations and this privacy policy.
          </p>
          <p>
            When you use this website, various personal data are collected. Personal data is data with which you can be personally identified. This privacy policy explains what data we collect and what we use it for. It also explains how and for what purpose this happens.
          </p>
          <p>
            We would like to point out that data transmission over the Internet (e.g., when communicating by e-mail) can have security gaps. Complete protection of data against access by third parties is not possible.
          </p>

          <h3>Note on the Responsible Body</h3>
          <p>
            The responsible body for data processing on this website is stated in the imprint.
          </p>
          <p>
            The responsible body is the natural or legal person who, alone or jointly with others, decides on the purposes and means of processing personal data (e.g., names, e-mail addresses, etc.).
          </p>

          <h3>Storage Duration</h3>
          <p>
            Unless a more specific storage period has been specified within this privacy policy, your personal data will remain with us until the purpose for data processing ceases to apply. If you assert a legitimate request for deletion or revoke your consent to data processing, your data will be deleted unless we have other legally permissible reasons for storing your personal data (e.g., tax or commercial law retention periods); in the latter case, the deletion will take place after these reasons cease to apply.
          </p>

          <h3>Revocation of Your Consent to Data Processing</h3>
          <p>
            Many data processing operations are only possible with your express consent. You can revoke consent you have already given at any time. The legality of the data processing carried out until the revocation remains unaffected by the revocation.
          </p>

          <h3>Right to Object to Data Collection in Special Cases and to Direct Advertising (Art. 21 GDPR)</h3>
          <p>
            IF DATA PROCESSING IS BASED ON ART. 6 ABS. 1 LIT. E OR F GDPR, YOU HAVE THE RIGHT AT ANY TIME TO OBJECT TO THE PROCESSING OF YOUR PERSONAL DATA FOR REASONS ARISING FROM YOUR PARTICULAR SITUATION; THIS ALSO APPLIES TO PROFILING BASED ON THESE PROVISIONS. THE RESPECTIVE LEGAL BASIS ON WHICH PROCESSING IS BASED CAN BE FOUND IN THIS PRIVACY POLICY. IF YOU OBJECT, WE WILL NO LONGER PROCESS YOUR CONCERNED PERSONAL DATA UNLESS WE CAN DEMONSTRATE COMPELLING LEGITIMATE GROUNDS FOR THE PROCESSING WHICH OVERRIDE YOUR INTERESTS, RIGHTS, AND FREEDOMS, OR THE PROCESSING SERVES THE ASSERTION, EXERCISE, OR DEFENSE OF LEGAL CLAIMS (OBJECTION ACCORDING TO ART. 21 ABS. 1 GDPR).
          </p>
          <p>
            IF YOUR PERSONAL DATA IS PROCESSED FOR DIRECT MARKETING PURPOSES, YOU HAVE THE RIGHT TO OBJECT AT ANY TIME TO THE PROCESSING OF PERSONAL DATA CONCERNING YOU FOR THE PURPOSE OF SUCH MARKETING; THIS ALSO APPLIES TO PROFILING TO THE EXTENT THAT IT IS RELATED TO SUCH DIRECT MARKETING. IF YOU OBJECT, YOUR PERSONAL DATA WILL SUBSEQUENTLY NO LONGER BE USED FOR DIRECT MARKETING PURPOSES (OBJECTION ACCORDING TO ART. 21 ABS. 2 GDPR).
          </p>

          <h3>Right to Lodge a Complaint with the Competent Supervisory Authority</h3>
          <p>
            In the event of violations of the GDPR, data subjects have the right to lodge a complaint with a supervisory authority, in particular in the Member State of their habitual residence, their place of work, or the place of the alleged violation. The right to lodge a complaint is without prejudice to any other administrative or judicial remedy.
          </p>

          <h3>Right to Data Portability</h3>
          <p>
            You have the right to have data that we process automatically on the basis of your consent or in fulfillment of a contract handed over to yourself or to a third party in a common, machine-readable format. If you request the direct transfer of the data to another responsible person, this will only be done insofar as it is technically feasible.
          </p>

          <h3>SSL or TLS Encryption</h3>
          <p>
            For security reasons and to protect the transmission of confidential content, such as orders or inquiries that you send to us as the site operator, this site uses SSL or TLS encryption. You can recognize an encrypted connection by the fact that the address line of the browser changes from "http://" to "https://" and by the lock symbol in your browser line.
          </p>
          <p>
            If SSL or TLS encryption is activated, the data you transmit to us cannot be read by third parties.
          </p>

          <h2>Data Collection on This Website</h2>
          <h3>Cookies</h3>
          <p>
            Our internet pages use so-called "cookies". Cookies are small text files and do not cause any damage to your end device. They are stored either temporarily for the duration of a session (session cookies) or permanently (permanent cookies) on your end device. Session cookies are automatically deleted after your visit. Permanent cookies remain stored on your end device until you delete them yourself or an automatic deletion is carried out by your web browser.
          </p>
          <p>
            In some cases, cookies from third-party companies can also be stored on your end device when you enter our site (third-party cookies). These enable us or you to use certain services of the third-party company (e.g., cookies for processing payment services).
          </p>
          <p>
            Cookies have various functions. Many cookies are technically necessary because certain website functions would not work without them (e.g., the shopping cart function or the display of videos). Other cookies are used to evaluate user behavior or display advertising.
          </p>
          <p>
            Cookies that are necessary to carry out the electronic communication process (necessary cookies) or to provide certain functions you desire (functional cookies, e.g., for the shopping cart function) or to optimize the website (e.g., cookies for measuring the web audience) are stored on the basis of Art. 6 Abs. 1 lit. f GDPR, unless another legal basis is specified. The website operator has a legitimate interest in storing cookies for the technically error-free and optimized provision of its services. If consent to the storage of cookies was requested, the storage of the cookies in question is based exclusively on this consent (Art. 6 Abs. 1 lit. a GDPR); the consent can be revoked at any time.
          </p>
          <p>
            You can set your browser so that you are informed about the setting of cookies and only allow cookies in individual cases, exclude the acceptance of cookies for certain cases or generally, and activate the automatic deletion of cookies when closing the browser. If cookies are deactivated, the functionality of this website may be limited.
          </p>
          <p>
            If cookies are used by third-party companies or for analysis purposes, we will inform you separately about this within the framework of this data protection declaration and, if necessary, request consent.
          </p>
          
          {/* Add more translated sections as needed based on the original German content */}
          {/* Example: Contact Form, Server Log Files, etc. */}

        </div>
      </div>
    </div>
  );
};

export default DatenschutzPage; 